import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {User} from '../../classes/user';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PasswordRequest} from '../../classes/PasswordRequest';
import {Environment} from '../../classes/environment';
import {MyReCaptchaService} from '../../services/my-recaptcha.service';
import {CustomerService} from 'src/app/services/customer.service';
import {SafeUrl} from '@angular/platform-browser';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-change-forgotten-password',
  templateUrl: './change-forgotten-password.component.html',
  styleUrls: ['./change-forgotten-password.component.css']
})
export class ChangeForgottenPasswordComponent implements OnInit, OnDestroy {

  changeForgotPasswordForm: UntypedFormGroup = new UntypedFormGroup({
    newPassword: new UntypedFormControl('', Validators.required),
    newPasswordConfirm: new UntypedFormControl('', Validators.required),
  });
  hideNewPassword = true;
  errorMsg = '';
  token = '';
  @Input() user = new User();
  @Output() done = new EventEmitter<boolean>();
  passwordRequest = new PasswordRequest();
  passwordCriteriaMet = false;
  private formChangesSub?: Subscription;
  private routeSub?: Subscription;

  logoSrc: SafeUrl = '';

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private matSnackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    @Inject('environment') private environment: Environment,
    private customerService: CustomerService,
    private recaptchaService: MyReCaptchaService
  ) {}

  ngOnInit(): void {

    this.logoSrc = this.customerService.getLoadedLogo();

    if (this.changeForgotPasswordForm.get('newPassword')?.value === this.changeForgotPasswordForm.get('newPasswordConfirm')?.value) {
      this.passwordCriteriaMet = this.arePasswordRequirementsMet();
    }

    this.formChangesSub = this.changeForgotPasswordForm.valueChanges.subscribe(() => {
      this.passwordCriteriaMet = this.arePasswordRequirementsMet();
    });
    this.passwordCriteriaMet = this.arePasswordRequirementsMet();

    this.routeSub = this.activatedRoute.params.subscribe(params => {
      this.token = params.token;
      console.log('Token:', this.token);
    });
  }

  ngOnDestroy(): void {
    this.formChangesSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }

  changePassword(): void {

    if (!this.isZeile6()) {
      console.log('Passwortbedingungen nicht erfüllt.');
      return;
    }

    this.errorMsg = '';

    this.recaptchaService.getToken('change_password').subscribe({
      next: (token: string) => {

        const newPassword = this.changeForgotPasswordForm.get('newPassword')?.value;
        const newPasswordConfirm = this.changeForgotPasswordForm.get('newPasswordConfirm')?.value;

        this.passwordRequest = new PasswordRequest();
        this.passwordRequest.password = newPassword;
        this.passwordRequest.passwordConfirm = newPasswordConfirm;
        this.passwordRequest.passwordToken = this.token;

        this.submitPasswordChange(token);
      },
      error: (err) => {
        console.error('Fehler beim Abrufen des Captcha-Tokens', err);
        this.errorMsg = 'Captcha konnte nicht verifiziert werden.';
      },
    });
  }

  get canSubmit(): boolean {
    return this.passwordCriteriaMet && this.changeForgotPasswordForm.valid;
  }

  isZeile1() {
    return !!(this.changeForgotPasswordForm.get('newPassword')?.value && this.changeForgotPasswordForm.get('newPassword')?.value.length >= 12);
  }

  isZeile2() {
    const hasCapitalLetter = /[A-Z]/;
    return this.changeForgotPasswordForm.get('newPassword')?.value && hasCapitalLetter.test(this.changeForgotPasswordForm.get('newPassword')?.value);
  }

  isZeile3() {
    const hasSmallLetter = /[a-z]/;
    return (this.changeForgotPasswordForm.get('newPassword')?.value) &&
      hasSmallLetter.test(this.changeForgotPasswordForm.get('newPassword')?.value);
  }

  isZeile4() {
    const hasSpecialCharacter = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.\/?]/;
    return (this.changeForgotPasswordForm.get('newPassword')?.value) &&
      hasSpecialCharacter.test(this.changeForgotPasswordForm.get('newPassword')?.value);
  }

  isZeile5() {
    const hasNumber = /\d/;
    return (this.changeForgotPasswordForm.get('newPassword')?.value) &&
      hasNumber.test(this.changeForgotPasswordForm.get('newPassword')?.value);
  }

  isZeile6() {
    return (this.changeForgotPasswordForm.get('newPassword')?.value) && this.changeForgotPasswordForm.get('newPasswordConfirm')?.value &&
      this.changeForgotPasswordForm.get('newPassword')?.value === this.changeForgotPasswordForm.get('newPasswordConfirm')?.value;
  }

  private arePasswordRequirementsMet(): boolean {
    return this.isZeile1() &&
      this.isZeile2() &&
      this.isZeile3() &&
      this.isZeile4() &&
      this.isZeile5() &&
      this.isZeile6();
  }

  private submitPasswordChange(token: string): void {
    this.passwordRequest.captchaResponse = token;
    this.authService.changeForgottenPassword(this.passwordRequest).subscribe({
      next: (success) => {
        if (success) {
          this.matSnackBar.open('Passwort gespeichert. Bitte erneut anmelden.', '', { duration: 4000 });
          this.done.emit(true);
          this.router.navigate(['/auth/login']);
          return;
        }
        console.log('Password change was not processed successfully.');
      },
      error: (error) => {
        console.log(error);
        this.errorMsg = 'Passwort konnte nicht geändert werden.';
      }
    });
  }
}
